import { render, staticRenderFns } from "./innovateTable.vue?vue&type=template&id=493b74c6&"
import script from "./innovateTable.vue?vue&type=script&lang=js&"
export * from "./innovateTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports